import cn from 'classnames';
import { NavLink } from 'react-router-dom';

import { CssUiComponent } from '@webapp/common/components/survey-custom';

import css from './slim-tabs.css';

export type SlimTab = {
    link: string;
    name: string;
    testId?: string;
};

export type SlibTabsItems = Array<SlimTab>;

export const SlimTabs: FC<{
    tabs: SlibTabsItems;
}> = ({ tabs }) => (
    <div className={cn(css.tabs, CssUiComponent.NO_PRINT)}>
        <div className={css.links}>
            {tabs.map(({ link, name, testId }) => (
                <NavLink activeClassName={css.active} className={css.tab} data-testid={testId} key={link} to={link}>
                    {name}
                </NavLink>
            ))}
        </div>
    </div>
);
